<div class="card bcx-card mb-3">
  <div class="card-body p-4">

    <h6 class="card-title fw-bold mb-3">Service Providers</h6>

    <ul class="list-group list-group-flush">
      <li
        v-for="(item, index) in providers"
        :key="index"
        class="list-group-item d-flex justify-content-between align-items-center px-0 py-3"
      >

        <div class="d-flex align-items-center gap-3">
          <div class="bcx-icon-chip bcx-icon-chip-sm">
            <i :class="item.icon"></i>
          </div>

          <div>
            <div class="fw-semibold">{{ item.name }}</div>
            <div class="text-secondary text-xxs">{{ item.category }}</div>
          </div>
        </div>

        <div class="fw-semibold text-danger text-xs text-end">
          {{ item.phone }}
        </div>

      </li>
    </ul>

  </div>
</div>
